import PropTypes from "prop-types";
import TableRow from "@mui/material/TableRow";
import TableHead from "@mui/material/TableHead";
import TableCell from "@mui/material/TableCell";

// ----------------------------------------------------------------------

export default function TableHeadCustom({
  headLabel = [],
  align = "left",
}) {
  return (
    <TableHead>
      <TableRow>
        {headLabel.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.align || align}
            sx={{
              textAlign: "left",
              width: headCell.width,
              minWidth: headCell.width,
              maxWidth: headCell.width,
              whiteSpace: 'nowrap',
              fontWeight: "bold",
            }}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

TableHeadCustom.propTypes = {
  headLabel: PropTypes.array.isRequired,
  align: PropTypes.oneOf(["left", "center", "right"]),
};
